export class DroppableInfo {
    constructor(data) {
        this.VSet(data);
    }
}
export class DraggableInfo {
    constructor(initialData) {
        this.VSet(initialData);
    }
}
